<template>
  <div>
    <div class="popover"
         :style="dimensions">
      <slot />
      <div class="popover__arrow-up"
           :style="arrowPosition"
           v-if="isArrowNeeded">
      </div>
    </div>
    <p4a-backdrop :isBackgroundRequired="isBackgroundRequired"
                  @close="close" />
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'Popover',
    props: {
      isBackgroundRequired: Boolean,
      isArrowNeeded: Boolean,
      eventObject: MouseEvent,
      width: Number,
      height: Number,
      align: String,
      center: Boolean
    },
    created () {
      this.currentTarget = _.clone(this.eventObject)
    },
    data () {
      return {
        currentTarget: null
      }
    },
    methods: {
      close () {
        this.$emit('close')
      }
    },
    computed: {
      arrowPosition () {
        return {
          width: '3px',
          height: '3px',
          position: 'absolute',
          bottom: this.height - 2 + 'px',
          left: this.center ? this.width / 2 + 'px' : '0'
        }
      },
      dimensions () {
        let topOffset = this.currentTarget.offsetTop + this.currentTarget.clientHeight + 5 + 'px'
        return {
          width: this.width + 'px',
          height: this.height + 'px',
          position: 'absolute',
          top: topOffset,
          left: this.center ?  '-' + (this.width - 30) / 2 + 'px' : '0',
          'z-index': 1500
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .popover {
    @extend %shadow;
    box-sizing: border-box;

    &__arrow-up {
      width: 0;
      height: 0;
      z-index: 950;
      padding-bottom: rem(1);
      border-bottom: rem(5) solid $white;
      border-left: rem(5) solid transparent;
      border-right: rem(5) solid transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Popover.vue